export const LOGISTICS_LIST_KEY = 'LOGISTICS_LIST';
export const LOGISTICS_ONE_KEY = 'LOGISTICS_ONE_KEY';
export const LOGISTICS_LIST_CATEGORY = 'LOGISTICS_LIST_CATEGORY';
export const LOGISTIC_STORES = 'LOGISTIC_STORES';
export const LOGISTIC_PRODUCTS_LIST_KEY = 'LOGISTIC_PRODUCTS_LIST_KEY';
export const LOGISTIC_DISTRIBUTION_CENTERS_LIST_KEY = 'LOGISTIC_DISTRIBUTION_CENTERS_LIST_KEY';
export const LOGISTIC_ROLES_KEY = 'LOGISTIC_ROLES_KEY';
export const LOGISTIC_STORES_LIST_KEY = 'LOGISTIC_STORES_LIST_KEY';
export const LOGISTIC_USERS_KEY = 'LOGISTIC_USERS_KEY';
